'use client'

import React, { Component } from 'react'
import { Button } from '@hashicorp/react-mds/src/components/button'
import Tippy from '@tippy.js/react'
import QuestionMark from './icons/question-mark'
import OpenSourceIcon from './icons/open-source-icon'
import ProIcon from './icons/pro-icon'
import PremiumIcon from './icons/premium-icon'

/**
 * Localized from legacy web-components — @hashicorp/react-packages v.2.1.4
 */

export default class Packages extends Component {
	render() {
		const data = this.props.data
		const icons = {
			'open-source': <OpenSourceIcon />,
			pro: <ProIcon />,
			premium: <PremiumIcon />,
		}

		return (
			<ul className="g-packages">
				{data.package_options.map((option) => (
					<li
						key={option.heading}
						className={option.enterprise ? 'enterprise' : ''}
					>
						<div className="top">
							<h2>
								{option.heading}{' '}
								{option.enterprise && <span className="tag">Enterprise</span>}
							</h2>
							{icons[option.slug]}
							<strong>{option.subheading}</strong>
							<Button
								className="g-btn"
								url={option.button_url}
								external={true}
								theme={
									option.enterprise
										? { variant: 'primary' }
										: {
												variant: 'secondary',
												brand: 'neutral',
												background: 'light',
										  }
								}
								title={option.enterprise ? 'Request Info' : 'Download Free'}
							/>
							{option.enterprise && (
								<p className="features-plus">
									All {option.heading === 'Pro' ? 'Open Source' : 'Pro'}{' '}
									features plus
								</p>
							)}
						</div>
						<ul>
							{option.package_features.map((feature) => (
								<li key={feature.text}>
									{(feature.url && (
										<a
											href={feature.url}
											rel="noopener noreferrer"
											target="_blank"
										>
											{feature.text}
										</a>
									)) ||
										feature.text}
									{feature.tooltip && (
										<Tippy
											content={feature.tooltip}
											placement="top"
											animation="fade"
											arrow={true}
										>
											<span className="g-tooltip">
												<QuestionMark />
											</span>
										</Tippy>
									)}
								</li>
							))}
						</ul>
					</li>
				))}
			</ul>
		)
	}
}
